import React, { useRef,useState } from "react";
import { motion, useInView } from "framer-motion";
import image from "../../assets/dd.jpeg";
// import api from '../services/api';
// import api from "services/api.js"
/* ================= ANIMATIONS ================= */
const container = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.18 },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.2, ease: [0.22, 1, 0.36, 1] },
  },
};

const floatCard = {
  hidden: { opacity: 0, y: 60, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1.4, ease: [0.22, 1, 0.36, 1] },
  },
};

/* ================= TYPING LOOP ================= */

function TypingLoop() {
  const text = "FREE DOOR TO DOOR COUNSELLING";
  const [displayed, setDisplayed] = React.useState("");
  const [index, setIndex] = React.useState(0);
  const [deleting, setDeleting] = React.useState(false);

  React.useEffect(() => {
    const typingSpeed = 110;   
    const deletingSpeed = 100; 
    const pauseTime = 1000;    

    let timeout;

    if (!deleting && index < text.length) {
      timeout = setTimeout(() => {
        setDisplayed(text.slice(0, index + 1));
        setIndex(index + 1);
      }, typingSpeed);
    } 
    else if (!deleting && index === text.length) {
      timeout = setTimeout(() => setDeleting(true), pauseTime);
    } 
    else if (deleting && index > 0) {
      timeout = setTimeout(() => {
        setDisplayed(text.slice(0, index - 1));
        setIndex(index - 1);
      }, deletingSpeed);
    } 
    else if (deleting && index === 0) {
      setDeleting(false);
    }

    return () => clearTimeout(timeout);
  }, [index, deleting]);

  return (
    <div className="inline-block px-6 py-3 border-2 border-[#203594] rounded-xl bg-white shadow-xl max-w-full overflow-hidden">
      <span className="text-lg sm:text-xl md:text-2xl font-bold text-[#203594] tracking-wide whitespace-nowrap block text-center">
        {displayed}
        <span className="animate-pulse ml-1">|</span>
      </span>
    </div>
  );
}

/* ================= MAIN COMPONENT ================= */

export default function Fields() {
  const ref = useRef(null);
const isInView = useInView(ref, { once: true });
    /* ================================
     1️⃣ STATE MANAGEMENT
  ================================== */
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  /* ================================
     2️⃣ HANDLE INPUT CHANGE
  ================================== */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* ================================
     3️⃣ VALIDATION FUNCTION
  ================================== */
  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!/^\d{10,}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid phone number (min 10 digits)";
    }

    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    return newErrors;
  };

  /* ================================
     4️⃣ FORM SUBMIT FUNCTION
  ================================== */
  const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validateForm();
  setErrors(validationErrors);

  if (Object.keys(validationErrors).length !== 0) return;

  try {
    setLoading(true);

    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/clients/contact`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    const data = await res.json();

    if (data.success) {
      alert("Request submitted successfully!");

      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
      });

      setErrors({});
    } else {
      alert(data.message || "Something went wrong");
    }

  } catch (error) {
    console.error("FORM SUBMIT ERROR:", error);
    alert("Server error. Please try again later.");
  } finally {
    setLoading(false);
  }
};

  /* ================================
     5️⃣ ANIMATION VARIANTS
  ================================== */
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  /* ================================
     6️⃣ UI
  ================================== */

  return (
    <section ref={ref} className="w-full bg-[#BFD8FF] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">

        {/* ================= LEFT FORM ================= */}
        <motion.div
          variants={floatCard}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="relative rounded-2xl shadow-2xl overflow-hidden backdrop-blur-xl 
                     hover:-translate-y-3 hover:shadow-[0_25px_80px_rgba(0,0,0,0.35)] 
                     transition-all duration-500"
        >

          {/* BACKGROUND IMAGE WITH ALT */}
          <img
            src={image}
            alt="Overseas education counselling background"
            className="absolute inset-0 w-full h-full object-cover scale-110 opacity-95 contrast-125 saturate-120"
          />

          {/* DARK GLASS OVERLAY */}
          <div className="absolute inset-0 bg-black/60 " />

          {/* FORM CONTENT */}
          <div className="relative z-10 p-8 md:p-10 text-white">

            <motion.h3 variants={fadeUp} className="text-xl font-semibold mb-6">
              Get Free Counselling
            </motion.h3>

            <motion.form
      onSubmit={handleSubmit}
      variants={container}
      initial="hidden"
      animate="visible"
      className="space-y-5"
    >
      {["name", "email", "phone", "city"].map((field, i) => (
        <motion.div key={i} variants={fadeUp}>
          <label className="block text-sm mb-1 font-medium text-white/90 capitalize">
            {field}
          </label>

          <input
            type={field === "email" ? "email" : "text"}
            name={field}
            value={formData[field]}
            onChange={handleChange}
            placeholder={`Enter your ${field}`}
            className="w-full px-4 py-3 rounded-lg bg-white/95 text-[#203594]
                       border border-white/40 focus:outline-none
                       focus:ring-2 focus:ring-white transition focus:scale-[1.02]"
          />

          {errors[field] && (
            <p className="text-red-400 text-sm mt-1">
              {errors[field]}
            </p>
          )}
        </motion.div>
      ))}

      <motion.button
        type="submit"
        disabled={loading}
        variants={fadeUp}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="w-full mt-4 bg-[#203594] text-white py-3 rounded-lg
                   font-semibold hover:bg-gray-100 hover:text-[#203594] transition shadow-lg hover:shadow-xl"
      >
        {loading ? "Submitting..." : "Submit Request"}
      </motion.button>
    </motion.form>
          </div>
        </motion.div>

        {/* ================= RIGHT CONTENT ================= */}
        <motion.div
          variants={container}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >

          {/* TYPING BADGE */}
          <motion.div variants={fadeUp} className="mb-5">
            <TypingLoop />
          </motion.div>

          <motion.h2
            variants={fadeUp}
            className="text-3xl md:text-4xl font-bold text-[#203594] leading-tight"
          >
            India’s First Home-Visit Overseas Education Guidance Service
          </motion.h2>

          <motion.p
            variants={fadeUp}
            className="mt-6 text-gray-700 font-bold leading-relaxed max-w-xl"
          >
            Our most experienced career counsellors visit students at their homes anywhere in India.
No travel. No waiting. No running behind consultancies.
Personal guidance for students and parents in the comfort of your home.
          </motion.p>

          <motion.ul
            variants={container}
            className="mt-6 space-y-3 text-gray-700"
          >
            {[
              "100% Free Counselling",
              "Any City Doorstep Support",
              "Course & University Guidance",
              "Visa & Documentation Help",
            ].map((item, i) => (
              <motion.li key={i} variants={fadeUp} className="flex items-center gap-2">
                ✔ {item}
              </motion.li>
            ))}
          </motion.ul>

        </motion.div>

      </div>
    </section>
  );
}
